export enum InvoiceEventTypeEnum {
  NoType = 'NO_TYPE',
  IncomingPayment = 'INCOMING_PAYMENT', // Inbetalning
  DebtCollection = 'DEBT_COLLECTION', // Inkasso
  Disputed = 'DISPUTED', // Bestriden
  PaymentDeferral = 'PAYMENT_DEFERRAL', // Betalningsanstånd
  InstallmentPlan = 'INSTALLMENT_PLAN', // Avbetalningsplan
  Reminded = 'REMINDED', // Påmind
  OutgoingPayment = 'OUTGOING_PAYMENT', // Utbetalning
  SetOff = 'SET_OFF', // Kvittning
  ReversedPayment = 'REVERSED_PAYMENT', // Reverserad inbetalning
  ReversedSetOff = 'REVERSED_SET_OFF', // Reverserad kvittning
  ReversedWriteOff = 'REVERSED_WRITE_OFF', // Reverserad bortskrivning
  WriteOff = 'WRITE_OFF', // Bortskrivning
}
